
export function CreateCustomEventDispatchHandler(root : HTMLElement, callback: () => void = ()=>{}){
    let dispatchTrainingEvent = (eventType:string, detail:any, bubbles:boolean = true) => {
        let event = new CustomEvent(eventType, {
            bubbles: bubbles,
            detail: detail
        });
        root.dispatchEvent(event);
    }

    let eventDispatchHandler = (eventType:string, detail:any, bubbles:boolean = true) => {
        // return (eventType:string, detail:any, bubbles:boolean = true) =>{
            return (e: Event) => {
                dispatchTrainingEvent(eventType, detail, bubbles);
                callback();
            }
        
    }

    return [eventDispatchHandler, dispatchTrainingEvent]
} 

